<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-row class="fill-height" no-gutters>
          <v-col class="col-12">
            <v-row>
              <v-col class="col-12">
                <v-card-title>
                  <v-row>
                    <v-col class="col-12 col-md-8">
                      <h1 class="primary-color">Interview Types</h1>
                    </v-col>
                    <v-spacer />
                    <v-col class="col-12 col-md-2">
                      <v-btn
                        class="new-item-btn float-right"
                        block
                        @click="openCreateInterviewType"
                      >
                        <v-icon size="20">mdi-plus</v-icon>
                        &nbsp;&nbsp;Create interview type
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>

                <v-alert
                  v-if="messageCreateInterviewType"
                  outlined
                  :color="successfullCreateInterviewType ? 'success' : 'error'"
                  :icon="successfullCreateInterviewType ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageCreateInterviewType }}
                </v-alert>
                <v-alert
                  v-if="messageDeleteInterviewType"
                  outlined
                  :color="successfullDeleteInterviewType ? 'success' : 'error'"
                  :icon="successfullDeleteInterviewType ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageDeleteInterviewType }}
                </v-alert>
                <v-alert
                  v-if="messageEditInterviewType"
                  outlined
                  :color="successfullEditInterviewType ? 'success' : 'error'"
                  :icon="successfullEditInterviewType ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageEditInterviewType }}
                </v-alert>
                <v-data-table
                  :headers="headers"
                  :items="interviewTypes"
                  item-key="id"
                  :loading="loading"
                  loading-text="Loading... Please, wait..."
                  :server-items-length="pagination.totalItems"
                  :items-per-page="pagination.itemsPerPage"
                  :page.sync="pagination.page"
                  item-class="text-wrap"
                  @update:page="handlePageChange"
                >
                  <template #[`item.createdAt`]="{ item }">
                    {{ item.createdAt | formatDate }}
                  </template>
                  <template #[`item.actions`]="{ item }">
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openShowDetails(item)">
                          <v-icon size="20" color="primary">mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Show details</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openEditInterviewType(item)">
                          <v-icon size="20" color="primary">mdi-square-edit-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit interview type</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openDeleteInterviewType(item)">
                          <v-icon size="20" color="error">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete interview type</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-alert
              v-if="messageInterviewTypes"
              class="mt-4"
              outlined
              :color="successfullInterviewTypes ? 'success' : 'error'"
              :icon="successfullInterviewTypes ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageInterviewTypes }}
            </v-alert>

            <v-alert
              v-if="messageComponents"
              class="mt-4"
              outlined
              :color="successfullComponents ? 'success' : 'error'"
              :icon="successfullComponents ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageComponents }}
            </v-alert>

            <v-alert
              v-if="messageAnalysisTypes"
              class="mt-4"
              outlined
              :color="successfullAnalysisTypes ? 'success' : 'error'"
              :icon="successfullAnalysisTypes ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageAnalysisTypes }}
            </v-alert>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>

    <v-dialog v-model="createInterviewTypeDialog" max-width="1000" persistent>
      <v-card>
        <v-form ref="createInterviewTypeForm" @submit.prevent="createInterviewType">
          <v-card-title class="px-6">
            <h5 class="primary-color">Create Interview Type</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="interviewType.name"
                    class="py-0 mb-6 no-border-radius"
                    label="Name *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-textarea
                    v-model="interviewType.description"
                    class="py-0 mb-6 no-border-radius"
                    label="Description"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-select
                    ref="menuAnalysisTypeCreate"
                    v-model="interviewType.interviewAnalysisTypeId"
                    class="py-0 mb-6 no-border-radius"
                    label="Analysis Type *"
                    :items="analysisTypesCreate"
                    item-text="name"
                    item-value="id"
                    :loading="loadingAnalysisTypesCreate"
                    attach
                  />
                </v-col>
                <v-col cols="12" class="pt-0">
                  <v-row>
                    <v-col cols="8" class="pt-4">
                      <h6 class="details-subtitles">Steps</h6>
                    </v-col>
                    <v-col cols="4" class="pt-4">
                      <v-btn
                        text
                        class="float-right"
                        color="primary"
                        @click="addStepCreate(interviewType)"
                      >
                        <v-icon size="20">mdi-plus</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <p class="information-text">
                    <v-icon size="20" color="primary">mdi-information</v-icon>&nbsp;&nbsp;Not
                    selecting 'Engine' implies that the AI will not check if the answer given by the
                    candidate is valid.
                  </p>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-data-table
                    :headers="headersSteps"
                    :items="interviewType.steps"
                    item-class="text-wrap"
                  >
                    <template #[`item.order`]="{ item }">
                      {{ item.order + 1 }}
                    </template>
                    <template #[`item.name`]="{ item }">
                      <v-text-field v-model="item.name" :rules="rules" />
                    </template>
                    <template #[`item.description`]="{ item }">
                      <v-textarea v-model="item.description" :rules="rules" />
                    </template>
                    <template #[`item.componentId`]="{ item }">
                      <v-select
                        v-model="item.componentId"
                        :items="componentsCreate"
                        item-text="name"
                        item-value="id"
                        :loading="loadingComponentsCreate"
                      />
                    </template>
                    <template #[`item.attempts`]="{ item }">
                      <v-text-field
                        v-if="
                          item.componentId === null ||
                          item.componentId === undefined ||
                          componentsCreate.filter(
                            (component) => component.id === item.componentId
                          )[0].type === 'QUESTION' ||
                          componentsCreate.filter(
                            (component) => component.id === item.componentId
                          )[0].type === 'TEST'
                        "
                        v-model="item.attempts"
                        type="number"
                        min="1"
                        step="1"
                      />
                      <p v-else>-</p>
                    </template>
                    <template #[`item.use_engine`]="{ item }">
                      <v-checkbox
                        v-if="
                          item.componentId === null ||
                          item.componentId === undefined ||
                          componentsCreate.filter(
                            (component) => component.id === item.componentId
                          )[0].type === 'QUESTION' ||
                          componentsCreate.filter(
                            (component) => component.id === item.componentId
                          )[0].type === 'TEST'
                        "
                        v-model="item.use_engine"
                      />
                      <p v-else>-</p>
                    </template>
                    <template #[`item.analysisRole`]="{ item }">
                      <v-select
                        v-model="item.analysisRole"
                        :items="analysisRoleOptions"
                        item-text="text"
                        item-value="value"
                        dense
                      />
                    </template>
                    <template #[`item.actions`]="{ item }">
                      <v-tooltip top>
                        <template #activator="{ on }">
                          <v-btn icon v-on="on" @click="deleteStep(interviewType, item)">
                            <v-icon size="20" color="error">mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Delete step</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-alert
                v-if="messageCreateInterviewTypeInside"
                class="mb-0 mt-3"
                outlined
                :color="successfullCreateInterviewTypeInside ? 'success' : 'error'"
                :icon="successfullCreateInterviewTypeInside ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageCreateInterviewTypeInside }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="cancelCreateInterviewType"> Cancel </v-btn>
            <v-btn v-if="!creatingInterviewType" type="submit" class="ok-modal"> Create </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editInterviewTypeDialog" max-width="1000" persistent>
      <v-card>
        <v-form ref="editInterviewTypeForm" @submit.prevent="editInterviewType">
          <v-card-title class="px-6">
            <h5 class="primary-color">Update Interview Type</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="itemToEdit.name"
                    class="py-0 mb-6 no-border-radius"
                    label="Name *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-textarea
                    v-model="itemToEdit.description"
                    class="py-0 mb-6 no-border-radius"
                    label="Description"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-select
                    v-model="itemToEdit.interviewAnalysisTypeId"
                    class="py-0 mb-6 no-border-radius"
                    label="Analysis Type *"
                    :items="analysisTypesEdit"
                    item-text="name"
                    item-value="id"
                  />
                </v-col>
                <v-col cols="12" class="pt-0">
                  <v-row>
                    <v-col cols="8" class="pt-4">
                      <h6 class="details-subtitles">Steps</h6>
                    </v-col>
                    <v-col cols="4" class="pt-4">
                      <v-btn
                        text
                        class="float-right"
                        color="primary"
                        @click="addStepEdit(itemToEdit)"
                      >
                        <v-icon size="20">mdi-plus</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <p class="information-text">
                    <v-icon size="20" color="primary">mdi-information</v-icon>&nbsp;&nbsp;Not
                    selecting 'Engine' implies that the AI will not check if the answer given by the
                    candidate is valid.
                  </p>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-data-table
                    :headers="headersSteps"
                    :items="itemToEdit.steps"
                    item-class="text-wrap"
                  >
                    <template #[`item.order`]="{ item }">
                      {{ item.order + 1 }}
                    </template>
                    <template #[`item.name`]="{ item }">
                      <v-text-field v-model="item.name" :rules="rules" />
                    </template>
                    <template #[`item.description`]="{ item }">
                      <v-text-field v-model="item.description" :rules="rules" />
                    </template>
                    <template #[`item.componentId`]="{ item }">
                      <v-select
                        v-model="item.componentId"
                        :items="componentsEdit"
                        item-text="name"
                        item-value="id"
                      />
                    </template>

                    <template #[`item.attempts`]="{ item, index }">
                      <v-text-field
                        v-if="
                          item.componentId === null ||
                          item.componentId === undefined ||
                          componentsEdit.filter((component) => component.id === item.componentId)[0]
                            .type === 'QUESTION' ||
                          componentsEdit.filter((component) => component.id === item.componentId)[0]
                            .type === 'TEST'
                        "
                        :key="item.componentId + '-text-' + index"
                        v-model="item.attempts"
                        type="number"
                        min="1"
                        step="1"
                      />
                      <p v-else>-</p>
                    </template>
                    <template #[`item.use_engine`]="{ item, index }">
                      <v-checkbox
                        v-if="
                          item.componentId === null ||
                          item.componentId === undefined ||
                          componentsEdit.filter((component) => component.id === item.componentId)[0]
                            .type === 'QUESTION' ||
                          componentsEdit.filter((component) => component.id === item.componentId)[0]
                            .type === 'TEST'
                        "
                        :key="item.componentId + '-' + index"
                        v-model="item.use_engine"
                      />
                      <p v-else>-</p>
                    </template>
                    <template #[`item.analysisRole`]="{ item }">
                      <v-select
                        v-model="item.analysisRole"
                        :items="analysisRoleOptions"
                        item-text="text"
                        item-value="value"
                        dense
                      />
                    </template>
                    <template #[`item.actions`]="{ item }">
                      <v-tooltip top>
                        <template #activator="{ on }">
                          <v-btn icon v-on="on" @click="deleteStep(itemToEdit, item)">
                            <v-icon size="20" color="error">mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Delete step</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-alert
                v-if="messageEditInterviewTypeInside"
                class="mb-0 mt-3"
                outlined
                :color="successfullEditInterviewTypeInside ? 'success' : 'error'"
                :icon="successfullEditInterviewTypeInside ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageEditInterviewTypeInside }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="editInterviewTypeDialog = false">
              Cancel
            </v-btn>
            <v-btn v-if="!editingInterviewType" type="submit" class="ok-modal"> Update </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteInterviewTypeDialog" max-width="500">
      <v-card>
        <v-card-title class="px-6">
          <h5 class="primary-color">Delete Interview Type</h5>
        </v-card-title>
        <v-card-text class="pb-0">
          <p class="mb-0">
            Do you really want to delete the selected interview type? <br />
            If so, press Confirm.
          </p>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn text class="cancel-modal" @click="deleteInterviewTypeDialog = false">
            Cancel
          </v-btn>

          <template v-if="!deletingInterviewType">
            <v-btn class="ok-modal" @click="deleteInterviewType"> Confirm </v-btn>
          </template>
          <v-btn v-else class="ok-modal" disabled @click="deleteInterviewType">
            <v-progress-circular indeterminate color="primary" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDetailsInterviewTypeDialog" max-width="1000">
      <v-card>
        <v-form ref="detailsInterviewTypeForm">
          <v-card-title class="px-6">
            <h5 class="primary-color">Details</h5>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Name:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">{{ itemToShow.name }}</p>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Description:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">{{ itemToShow.description }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Analysis Type:</h6>
                </v-col>
                <v-col cols="9">
                  <p v-if="itemToShow.interviewAnalysisType" class="mb-0">
                    {{ itemToShow.interviewAnalysisType.name }}
                  </p>
                </v-col>
              </v-row>
              <v-row v-if="itemToShow.steps !== undefined && itemToShow.steps.length == 0">
                <v-col cols="3">
                  <h6 class="details-subtitles">Steps:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">Interview type with no associated steps</p>
                </v-col>
              </v-row>

              <v-row v-else>
                <v-col cols="12" class="pb-0">
                  <h6 class="details-subtitles">Steps:</h6>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-data-table
                    :headers="headersDetails"
                    :items="itemToShow.steps"
                    item-key="itemToShow.id"
                    item-class="text-wrap"
                  >
                    <template #[`item.order`]="{ item }">
                      {{ item.order + 1 }}
                    </template>
                    <template #[`item.attempts`]="{ item }">
                      <template
                        v-if="item.component.type === 'TEST' || item.component.type === 'QUESTION'"
                        >{{ item.attempts }}</template
                      >
                      <template v-else>-</template>
                    </template>
                    <template #[`item.useEngine`]="{ item }">
                      <template
                        v-if="item.component.type === 'TEST' || item.component.type === 'QUESTION'"
                      >
                        <v-card-text v-if="item.useEngine" class="d-flex align-end"
                          ><v-icon size="20" color="green">mdi-check</v-icon></v-card-text
                        >
                        <v-card-text v-else class="d-flex align-end"
                          ><v-icon size="20" color="red">mdi-close</v-icon></v-card-text
                        >
                      </template>
                      <template v-else>-</template>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="px-4 pb-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="showDetailsInterviewTypeDialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ComponentsDataService from '@/services/ComponentsDataService';
import InterviewsDataService from '@/services/InterviewsDataService';

export default {
  name: 'InterviewTypesList',
  data() {
    return {
      interviewTypes: [],
      successfullInterviewTypes: false,
      messageInterviewTypes: '',
      componentsCreate: [],
      componentsEdit: [],
      successfullComponents: false,
      messageComponents: '',
      analysisTypesCreate: [],
      analysisTypesEdit: [],
      successfullAnalysisTypes: false,
      messageAnalysisTypes: '',
      loading: false,
      successfullCreateInterviewType: false,
      messageCreateInterviewType: '',
      successfullCreateInterviewTypeInside: false,
      messageCreateInterviewTypeInside: '',
      successfullEditInterviewType: false,
      messageEditInterviewType: '',
      successfullEditInterviewTypeInside: false,
      messageEditInterviewTypeInside: '',
      successfullDeleteInterviewType: false,
      messageDeleteInterviewType: '',
      headers: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Steps', value: 'steps.length', sortable: false },
        {
          text: 'Analysis Type',
          value: 'interviewAnalysisType.name',
          sortable: false,
        },
        { text: 'Created at', value: 'createdAt', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalPages: 1,
        totalItems: 0,
      },
      headersSteps: [
        { text: 'Step', value: 'order', sortable: false },
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Description', value: 'description', sortable: false },
        {
          text: 'Component',
          value: 'componentId',
          sortable: false,
          width: '150px',
        },
        {
          text: 'Attempts',
          value: 'attempts',
          sortable: false,
          width: '100px',
        },
        { text: 'Engine', value: 'use_engine', sortable: false },
        {
          text: 'Role',
          value: 'analysisRole',
          sortable: false,
          width: '180px',
        },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      analysisRoleOptions: [
        { text: 'None', value: 'NONE' },
        { text: 'Scenario', value: 'SCENARIO' },
        { text: 'Cultural – positive', value: 'CULTURE_POSITIVE' },
        { text: 'Cultural – negative', value: 'CULTURE_NEGATIVE' },
        { text: 'Belief ranking', value: 'BELIEF_ORDER' },
        { text: 'Client question', value: 'CLIENT_QUESTION' },
      ],
      interviewType: {
        name: '',
        description: '',
        interviewAnalysisTypeId: null,
        steps: [],
      },
      rules: [(v) => !!v || 'Required field'],
      createInterviewTypeDialog: false,
      creatingInterviewType: false,
      editInterviewTypeDialog: false,
      editingInterviewType: false,
      deleteInterviewTypeDialog: false,
      deletingInterviewType: false,
      itemToEdit: { steps: [] },
      itemToDelete: {},
      itemToShow: {},
      headersDetails: [
        { text: 'Step', value: 'order', sortable: false, width: '50px' },
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Component', value: 'component.label', sortable: false },
        {
          text: 'Attempts',
          value: 'attempts',
          sortable: false,
          width: '100px',
        },
        { text: 'Engine', value: 'useEngine', sortable: false, width: '100px' },
        { text: 'Role', value: 'analysisRole', sortable: false, width: '140px' },
      ],
      showDetailsInterviewTypeDialog: false,

      pageAnalysisTypesCreate: 1,
      totalItemsAnalysisTypesCreate: 0,
      itemsPerPageAnalysisTypesCreate: 10,
      loadingAnalysisTypesCreate: false,
      isMenuOpenAnalysisTypesCreate: false,

      pageComponentsCreate: 1,
      totalItemsComponentsCreate: 0,
      itemsPerPageComponentsCreate: 10,
      loadingComponentsCreate: false,
      isMenuOpenComponentsCreate: false,
    };
  },
  async mounted() {
    await this.getAllInterviewAnalysisTypesEdit();
    await this.getAllComponents();
    await this.getAllInterviewTypes(1);
  },
  methods: {
    getAllInterviewTypes(page) {
      this.loading = true;

      InterviewsDataService.findAllInterviewTypes(page, this.pagination.itemsPerPage).then(
        (response) => {
          if (response.status == 200) {
            this.interviewTypes = response.data.data;

            if (this.interviewTypes.length !== 0) {
              this.pagination.page = page;
              this.pagination.totalPages = response.data.links.totalPages || 1;

              this.pagination.totalItems =
                response.data.links.totalItems ||
                this.pagination.totalPages * this.pagination.itemsPerPage;
            }
          } else {
            this.successfullInterviewTypes = false;
            this.messageInterviewTypes =
              'An error has occurred retrieving the list of interview types. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullInterviewTypes = false;
          this.messageInterviewTypes =
            'An error has occurred retrieving the list of interview types. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    handlePageChange(newPage) {
      this.pagination.page = newPage;
      this.getAllInterviewTypes(newPage);
    },
    getAllComponents() {
      this.loading = true;

      ComponentsDataService.findAll(-1, 0).then(
        (response) => {
          if (response.status == 200) {
            this.componentsEdit = response.data.data;
            this.componentsCreate = response.data.data;
          } else {
            this.successfullComponents = false;
            this.messageComponents =
              'An error has occurred retrieving the list of components. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullComponents = false;
          this.messageComponents =
            'An error has occurred retrieving the list of components. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    observeMenuCreateAnalysisTypes() {
      const menu = this.$refs.menuAnalysisTypeCreate;
      if (!menu) return;

      const observer = new MutationObserver(() => {
        this.$nextTick(() => {
          const dropdown = menu.$el.querySelector('.v-menu__content');

          if (dropdown && !this.isMenuOpenAnalysisTypesCreate) {
            this.onOpenAnalysisTypesCreate(true);
            this.isMenuOpenAnalysisTypesCreate = true;
            dropdown.addEventListener('scroll', this.onScrollAnalysisTypesCreate);
          } else if (!dropdown && this.isMenuOpenAnalysisTypesCreate) {
            this.onOpenAnalysisTypesCreate(false);
            this.isMenuOpenAnalysisTypesCreate = false;
          }
        });
      });

      observer.observe(menu.$el, { childList: true, subtree: true });
    },
    getAllInterviewAnalysisTypesCreate() {
      if (this.loadingAnalysisTypesCreate) return;
      this.loadingAnalysisTypesCreate = true;

      InterviewsDataService.findAllInterviewAnalysisTypes(
        this.pageAnalysisTypesCreate,
        this.itemsPerPageAnalysisTypesCreate
      ).then(
        (response) => {
          if (response.status == 200) {
            if (response.data.data.length === 0) {
              this.loadingAnalysisTypesCreate = false;
              return;
            }

            this.analysisTypesCreate = [...this.analysisTypesCreate, ...response.data.data];
            this.totalItemsAnalysisTypesCreate = response.data.links.totalItems;
            this.pageAnalysisTypesCreate++;
          } else {
            this.successfullAnalysisTypes = false;
            this.messageAnalysisTypes =
              'An error has occurred retrieving the list of analysis types. Please, try again later.';
          }

          this.loadingAnalysisTypesCreate = false;
        },
        (error) => {
          this.successfullAnalysisTypes = false;
          this.messageAnalysisTypes =
            'An error has occurred retrieving the list of analysis types. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loadingAnalysisTypesCreate = false;
        }
      );
    },
    onOpenAnalysisTypesCreate(isOpen) {
      if (isOpen && this.analysisTypesCreate.length === 0) {
        this.getAllInterviewAnalysisTypesCreate();
      }
    },
    onScrollAnalysisTypesCreate(event) {
      const dropdown = event.target;

      if (
        dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 &&
        !this.loadingAnalysisTypesCreate
      ) {
        this.getAllInterviewAnalysisTypesCreate();
      }
    },
    getAllInterviewAnalysisTypesEdit() {
      this.loading = true;

      InterviewsDataService.findAllInterviewAnalysisTypes(-1, 0).then(
        (response) => {
          if (response.status == 200) {
            this.analysisTypesEdit = response.data.data;
          } else {
            this.successfullAnalysisTypes = false;
            this.messageAnalysisTypes =
              'An error has occurred retrieving the list of analysis types. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullAnalysisTypes = false;
          this.messageAnalysisTypes =
            'An error has occurred retrieving the list of analysis types. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    openCreateInterviewType() {
      this.createInterviewTypeDialog = true;

      this.$nextTick(() => {
        this.observeMenuCreateAnalysisTypes();
      });
    },
    addStepCreate(interType) {
      interType.steps.push({
        name: '',
        description: '',
        order: interType.steps.length,
        componentId: null,
        attempts: 1,
        use_engine: false,
        analysisRole: 'NONE',
      });
    },
    addStepEdit(interType) {
      interType.steps.push({
        name: '',
        description: '',
        order: interType.steps.length,
        componentId: null,
        attempts: 1,
        use_engine: false,
        analysisRole: 'NONE',
      });
    },
    deleteStep(interType, step) {
      interType.steps.splice(step.order, 1);

      for (let i = 0; i < interType.steps.length; i++) {
        interType.steps[i].order = i;
      }
    },
    createInterviewType() {
      this.successfullCreateInterviewType = true;
      this.messageCreateInterviewType = '';

      if (this.$refs.createInterviewTypeForm.validate()) {
        if (
          this.interviewType.steps.length > 0 &&
          this.interviewType.interviewAnalysisTypeId !== null
        ) {
          this.creatingInterviewType = true;

          if (
            this.interviewType.description == null ||
            this.interviewType.description == undefined ||
            this.interviewType.description.trim() == ''
          )
            this.interviewType.description = null;

          this.interviewType.steps.forEach((step) => {
            if (
              step.componentId === null ||
              this.componentsCreate.filter((component) => component.id === step.componentId)[0]
                .type === 'QUESTION' ||
              this.componentsCreate.filter((component) => component.id === step.componentId)[0]
                .type === 'TEST'
            )
              step.attempts = parseInt(step.attempts);
            else {
              step.attempts = null;
              step.use_engine = null;
            }
          });

          this.interviewType.steps.forEach((step) => {
            if (step.attempts == null) delete step.attempts;
            if (step.use_engine == null) delete step.use_engine;
          });

          InterviewsDataService.createInterviewType(this.interviewType).then(
            (response) => {
              if (response.status == 201) {
                this.getAllInterviewTypes(1);

                this.messageCreateInterviewType = '';
                this.successfullCreateInterviewType = true;

                setTimeout(() => {
                  this.messageCreateInterviewType = 'Interview Type successfully created.';
                }, 10);
              } else {
                this.messageCreateInterviewType = '';
                this.successfullCreateInterviewType = true;

                setTimeout(() => {
                  this.messageCreateInterviewType =
                    'An error has occurred creating the interview type. Please, try again later.';
                }, 10);
              }

              this.createInterviewTypeDialog = false;
              this.creatingInterviewType = false;
              this.interviewType = {
                name: '',
                description: '',
                interviewAnalysisTypeId: null,
                steps: [],
              };
            },
            (error) => {
              this.messageCreateInterviewTypeInside = '';
              this.messageCreateInterviewType = '';

              if (error.response.status === 409) {
                this.successfullCreateInterviewTypeInside = false;

                setTimeout(() => {
                  this.messageCreateInterviewTypeInside =
                    'Interview Type already in use. Please, change its name.';
                }, 10);
              } else if (error.response.status === 401 || error.response.status === 403) {
                localStorage.removeItem('user');
                this.$router.push('/');
              } else {
                this.successfullCreateInterviewType = false;

                setTimeout(() => {
                  this.messageCreateInterviewType =
                    'An error has occurred creating the interview type. Please, try again later.';
                }, 10);

                this.createInterviewTypeDialog = false;
                this.interviewType = {
                  name: '',
                  description: '',
                  interviewAnalysisTypeId: null,
                  steps: [],
                };
              }

              console.error(
                (error.response && error.response.data) || error.message || error.toString()
              );

              this.creatingInterviewType = false;
            }
          );
        } else {
          this.messageCreateInterviewTypeInside = '';
          this.successfullCreateInterviewTypeInside = false;

          setTimeout(() => {
            this.messageCreateInterviewTypeInside = 'Please, fill all fields.';
          }, 10);
        }
      }
    },
    cancelCreateInterviewType() {
      this.createInterviewTypeDialog = false;
      this.interviewType = {
        name: '',
        description: '',
        interviewAnalysisTypeId: null,
        steps: [],
      };
    },
    openEditInterviewType(interviewType) {
      this.itemToEdit = { ...interviewType };

      this.itemToEdit.interviewAnalysisTypeId = this.itemToEdit.interviewAnalysisType
        ? this.itemToEdit.interviewAnalysisType.id
        : null;

      this.itemToEdit.steps.forEach((step) => {
        step.componentId = step.component.id;
        step.use_engine = step.useEngine;
        step.analysisRole = step.analysisRole ?? 'NONE';
      });

      this.editInterviewTypeDialog = true;
    },
    editInterviewType() {
      this.successfullEditInterviewType = true;

      if (this.$refs.editInterviewTypeForm.validate()) {
        if (this.itemToEdit.steps.length > 0 && this.itemToEdit.interviewAnalysisTypeId !== null) {
          this.editingInterviewType = true;

          if (
            this.itemToEdit.description == null ||
            this.itemToEdit.description == undefined ||
            this.itemToEdit.description.trim() == ''
          )
            this.itemToEdit.description = null;

          this.itemToEdit.steps.forEach((step) => {
            if (
              step.componentId === null ||
              this.componentsEdit.filter((component) => component.id === step.componentId)[0]
                .type === 'QUESTION' ||
              this.componentsEdit.filter((component) => component.id === step.componentId)[0]
                .type === 'TEST'
            )
              step.attempts = parseInt(step.attempts);
            else {
              step.attempts = 1;
              step.use_engine = false;
            }
          });

          InterviewsDataService.updateInterviewType(this.itemToEdit).then(
            (response) => {
              if (response.status == 204) {
                this.getAllInterviewTypes(1);
                this.messageEditInterviewType = '';
                this.successfullEditInterviewType = true;

                setTimeout(() => {
                  this.messageEditInterviewType = 'Interview Type successfully updated.';
                }, 10);
              } else {
                this.messageEditInterviewType = '';
                this.successfullEditInterviewType = true;

                setTimeout(() => {
                  this.messageEditInterviewType =
                    'An error has occurred updating the interview type. Please, try again later.';
                }, 10);
              }

              this.editInterviewTypeDialog = false;
              this.editingInterviewType = false;
              this.itemToEdit = {};
            },
            (error) => {
              this.messageEditInterviewTypeInside = '';
              this.messageEditInterviewType = '';

              if (error.response.status === 409) {
                this.successfullEditInterviewTypeInside = false;

                setTimeout(() => {
                  this.messageEditInterviewTypeInside =
                    'Interview Type already in use. Please, change its name.';
                }, 10);
              } else if (error.response.status === 401 || error.response.status === 403) {
                localStorage.removeItem('user');
                this.$router.push('/');
              } else {
                this.successfullEditInterviewType = false;

                setTimeout(() => {
                  this.messageEditInterviewType =
                    'An error has occurred updating the interview type. Please, try again later.';
                }, 10);

                this.editInterviewTypeDialog = false;
                this.itemToEdit = {};
              }

              console.error(
                (error.response && error.response.data) || error.message || error.toString()
              );

              this.editingInterviewType = false;
            }
          );
        } else {
          this.messageEditInterviewTypeInside = '';
          this.successfullEditInterviewTypeInside = false;

          setTimeout(() => {
            this.messageEditInterviewTypeInside = 'Please, fill all fields.';
          }, 10);
        }
      }
    },
    openDeleteInterviewType(interviewType) {
      this.itemToDelete = { ...interviewType };
      this.deleteInterviewTypeDialog = true;
    },
    deleteInterviewType() {
      if (this.itemToDelete.id !== undefined) {
        this.deletingInterviewType = true;

        InterviewsDataService.deleteInterviewType(this.itemToDelete.id).then(
          (response) => {
            if (response.status == 204) {
              this.getAllInterviewTypes(1);
              this.messageDeleteInterviewType = '';
              this.successfullDeleteInterviewType = true;

              setTimeout(() => {
                this.messageDeleteInterviewType = 'Interview Type successfully deleted.';
              }, 10);
            } else {
              this.messageDeleteInterviewType = '';
              this.successfullDeleteInterviewType = false;

              setTimeout(() => {
                this.messageDeleteInterviewType =
                  'An error has occurred deleting the interview type. Please, try again later.';
              }, 10);
            }

            this.deleteInterviewTypeDialog = false;
            this.deletingInterviewType = false;
            this.itemToDelete = {};
          },
          (error) => {
            this.messageDeleteInterviewType = '';
            this.successfullDeleteInterviewType = false;

            setTimeout(() => {
              this.messageDeleteInterviewType =
                'An error has occurred deleting the interview type. Please, try again later.';
            }, 10);

            this.deleteInterviewTypeDialog = false;
            this.itemToDelete = {};

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/');
            }

            this.deletingInterviewType = false;
          }
        );
      } else {
        this.messageDeleteInterviewType = '';
        this.successfullDeleteInterviewType = false;

        setTimeout(() => {
          this.messageDeleteInterviewType =
            'An error has occurred deleting the interview type. Please, try again later.';
        }, 10);

        this.deleteInterviewTypeDialog = false;
        this.itemToDelete = {};
      }
    },
    openShowDetails(interviewType) {
      this.itemToShow = { ...interviewType };
      this.showDetailsInterviewTypeDialog = true;
    },
  },
};
</script>
